export enum StoreNames {
  Account = 'account',

  AllocationsNew = 'allocations-new',
  AllocationsGroupsPage = 'allocations-groups-page',

  Allocations = 'allocations',
  AllocationsApprovedInventoriesPage = 'allocations-approved-inventories-page',
  AllocationsApprovedProductLocationsPage = 'allocations-approved-product-locations-page',
  AllocationsPendingInventoriesPage = 'allocations-pending-inventories-page',
  AllocationsPendingProductLocationsPage = 'allocations-pending-product-locations-page',
  AllocationsScheduledProductLocationsPage = 'allocations-scheduled-product-locations-page',
  AllocationsSettings = 'allocations-settings',
  AllocationsGroupAssortmentGroupLocationsPage = 'allocations-group-assortment-group-locations-page',

  HomeKpiAndMetrics = 'home-kpi-and-metrics',
  HomeLocationsPerformance = 'home-locations-performance',
  HomeCatalogPerformance = 'home-catalog-performance',

  OnboardingHints = 'onboarding-hints',

  Data = 'data',
  I18n = 'i18n',
  InventoryAvoidReplenishmentStatus = 'inventory-avoid-replenishment-status',
  InventoryInventoriesPage = 'inventory-inventories-page',
  InventoryLocationsPage = 'inventory-locations-page',
  InventorySkusPage = 'inventory-skus-page',
  InventoryProductLocationsPage = 'inventory-product-locations-page',
  ReplenishmentLocationsPage = 'replenishment-locations-page',
  ReplenishmentOverviewPage = 'replenishment-overview-page',
  ReplenishmentInventoriesPage = 'replenishment-inventories-page',
  ReplenishmentLocationDetailsPage = 'replenishment-location-details-page',
  ReplenishmentProductDetailsPage = 'replenishment-product-details-page',
  SkuChart = 'sku-chart',
  SpecialEventPageStore = 'special-event-page',
  SpecialEventsStore = 'special-events',
  SpecialEventsApprovedPageStore = 'special-events-approved-page',
  SpecialEventsUpcomingPageStore = 'special-events-upcoming-page',
  SpecialEventsPendingPageStore = 'special-events-pending-page',
  Superset = 'superset',
  SupersetKeyMeta = 'superset-key-meta',
  SupersetDashboards = 'superset-dashboards',
  SystemServicesStatus = 'system-services-status',
  User = 'user',
  StoreTransferSettings = 'store-transfer-settings',
  StoreTransferTripDetails = 'store-transfer-trip-details',
  StoreTransferSkuTripsPage = 'store-transfer-sku-trips-page',
  DownloadsWidget = 'downloads-widget',
  DownloadCenter = 'download-center-page',
  Announcements = 'announcements',
}
